<script setup>
const route = useRoute()
const isMobile = computed(() => isMobileDevice());
const open = ref(true);

onMounted(() => {
  if (isMobile.value && route.path.startsWith("/sports")) {
    open.value = false;
  }
})

watch(() => route.path, (newPath) => {
  if (isMobile.value && newPath.startsWith("/sports")) {
    open.value = false;
  } else {
    open.value = true;
  }
})
// const menuItensCount = slots.body().filter(element => element.type.__name === 'DropdownItem').length

</script>

<template>
    <div
        class="flex flex-col border-b border-brand-separator last:border-b-0 cursor-pointer">
      <div
          class="flex justify-between items-center font-bold text-sm pt-4 px-6 text-bzMenuText uppercase mb-4"
          @click="open = !open"
          v-if="$slots.header">
        <slot name="header"/>
        <Icon
            name="material-symbols:keyboard-arrow-down-rounded"
            size="24"
            class="duration-300"
            :class="{ 'rotate-180': open }"/>
      </div>

      <Transition name="fade" >
        <div
            class="flex flex-col content-between gap-y-4 px-6 cursor-pointer group overflow-y-hidden after:content[''] after:h-[1px]"
            v-show="open">
          <slot name="body"/>
        </div>
      </Transition>
    </div>
</template>

<style scoped>

.fade-enter-active {
  animation: drop-animation 400ms reverse;
}

.fade-leave-to {
  animation: drop-animation 400ms;
}

@keyframes drop-animation {
  0% {
    max-height: calc((30px + 1.5rem) * 9);
    opacity: 1;
  }

  100% {
    max-height: 0;
    opacity: 0.3;
  }
}


</style>
